'use client';

import { reactive } from '@legendapp/state/react';
import { type ReactNode } from 'react';
import DraggableXContainer from '@/components/DraggableXContainer';
import { useTabState } from '@/components/tabs/TabProvider';
import './tabs.css';

export type TabScrollerProps = {
    children: ReactNode;
};
export const ReactiveConstrainedWidthHorizonalScroller = reactive(DraggableXContainer);

export default function TabScroller({ children }: TabScrollerProps) {
    const tabState$ = useTabState();
    return (
        <DraggableXContainer className="pill-scroll-container" containerClassName="pill-clip-container rounded-full" activeElement$={tabState$.activeTab} role="tablist">
            {children}
        </DraggableXContainer>
    );
}
